/** MeetingFilters — source (multi-select) / status / date filters for the meeting list. */

import { DatePicker, Select, Space } from "antd";
import dayjs, { type Dayjs } from "dayjs";
import {
  MEETING_SOURCE_OPTIONS,
  MEETING_STATUS_OPTIONS,
  type MeetingSource,
  type MeetingStatus,
} from "../../types/meeting";

const { RangePicker } = DatePicker;

export interface MeetingFilterValues {
  /** Multi-select source filter. Undefined / empty = all sources. */
  sources?: MeetingSource[];
  status?: MeetingStatus;
  dateFrom?: string;
  dateTo?: string;
}

interface MeetingFiltersProps {
  value: MeetingFilterValues;
  onChange: (next: MeetingFilterValues) => void;
}

export default function MeetingFilters({ value, onChange }: MeetingFiltersProps) {
  const dateRange: [Dayjs, Dayjs] | null =
    value.dateFrom && value.dateTo ? [dayjs(value.dateFrom), dayjs(value.dateTo)] : null;

  return (
    <Space size="middle" wrap>
      <Select<MeetingSource[]>
        mode="multiple"
        allowClear
        placeholder="全部来源"
        style={{ minWidth: 220, maxWidth: 360 }}
        value={value.sources ?? []}
        options={MEETING_SOURCE_OPTIONS}
        maxTagCount="responsive"
        onChange={(v) => onChange({ ...value, sources: v.length > 0 ? v : undefined })}
      />
      <Select<MeetingStatus | undefined>
        allowClear
        placeholder="全部状态"
        style={{ width: 140 }}
        value={value.status}
        options={MEETING_STATUS_OPTIONS}
        onChange={(v) => onChange({ ...value, status: v })}
      />
      <RangePicker
        showTime
        value={dateRange ?? undefined}
        onChange={(range) => {
          if (!range || !range[0] || !range[1]) {
            onChange({ ...value, dateFrom: undefined, dateTo: undefined });
            return;
          }
          onChange({
            ...value,
            dateFrom: range[0]!.toISOString(),
            dateTo: range[1]!.toISOString(),
          });
        }}
      />
    </Space>
  );
}
